import _ from "lodash";
import {DoorModel} from "./door-model";

export class UserSessionService {

    constructor($log, $rootScope, $http, $q, AppConfig) {
        'ngInject';

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$q = $q;
        this.appConfig = AppConfig;

        this._baseImage = null;
        this._renderedImage = null;
        this._doorImages = null;
        this._doors = [];
        this._selectedDoor = null;

        this._data = null;

        this.canceler = null;

        //this.setupTestData();
    }

    getBaseImage() {
        return this._baseImage;
    }

    setBaseImage(val) {
        this._baseImage = val;
    }

    getRenderedImage() {
        return this._renderedImage;
    }

    getImage() {
        return this._renderedImage || this._baseImage;
    }

    getDoorImages() {
        return this._doorImages;
    }

    getData() {
        return this._data;
    }

    renderImage() {

        let doorConfigs = _.without(this.getDoorConfigs(), null);

        // if no configured doors, don't render
        //if (!doorConfigs.length) return;

        if (this.canceler) {
            this.canceler.resolve();
        }

        this.canceler = this.$q.defer();

        this.$http.post(this.appConfig.api_endpoint + '/api/render', {
            image: this._baseImage.file,
            doors: doorConfigs
        }, {timeout: this.canceler.promise}).then((response) => {
            this._data = response.data;
            this._baseImage = response.data.before;
            this._renderedImage = response.data.after;
            response.data.doors.forEach((door, index) => {
                this._doors[index].setPreview(door);
            });
            this.$rootScope.$emit('UserSessionService::imageRendered');
        });
    }

    getDoorConfigs() {

        return _.map(this._doors, (door) => {
            return door.getConfig();
        });

/*        return _.without(this._doors.map((door) => {
            return door.getConfig();
        }), null);*/
    }

    getDoors() {
        return this._doors;
    }

    setDoors(val) {
        this._doors = val;
    }

    getSelectedDoor() {
        return this._selectedDoor;
    }

    setSelectedDoor(val) {
        if (val === this._selectedDoor) return;

        this._selectedDoor = val;

        this.$log.debug('$emit::UserSessionService::selectedDoorUpdated');
        this.$rootScope.$emit('UserSessionService::selectedDoorUpdated');
    }

    addDoor(options) {

        //let startingPointX = Math.round(Math.random() * 500);
        //let startingPointY = Math.round(Math.random() * 500);

        let startingPointX = 0;
        let startingPointY = 0;

        options.points = options.points || [startingPointX + 10, startingPointY + 10, startingPointX + 300, startingPointY + 10, startingPointX + 300, startingPointY + 100, startingPointX + 10, startingPointY + 100];

        let door = new DoorModel(options);

        this._doors.push(door);

        this._selectedDoor = door;

        this.$rootScope.$emit('UserSessionService::doorsUpdated');
    }

    removeDoor(door) {
        let index = this._doors.indexOf(door);

        this._doors.splice(index, 1);

        if (index >= this._doors.length) {
            this._selectedDoor = this._doors[this._doors.length - 1];
        } else {
            this._selectedDoor = this._doors[index];
        }

        this.$rootScope.$emit('UserSessionService::doorsUpdated');
    }

    allDoorsConfigured() {

        return _.every(this._doors, (door) => {
            return door.getProduct() !== null;
        });

    }

    requestQuote(userData) {

        let data = {};

        _.extend(data,
            userData,
            {
                image: this.getBaseImage().file
            },
            {
                doors: this.getDoorConfigs()
            });

        this.loading = true;

        return this.$http.post(this.appConfig.api_endpoint + '/api/request-quote', data).then((response) => {
            return response;
        });

    }

    downloadDesign() {
        let data = {};

        _.extend(data,
            {
                image: this.getBaseImage().file
            },
            {
                doors: this.getDoorConfigs()
            });

        this.loading = true;

        return this.$http.post(this.appConfig.api_endpoint + '/api/download-design', data).then((response) => {
            return response.data;
        });
    }

    emailDesign(userData) {

        let data = {};

        _.extend(data,
            userData,
            {
                image: this.getBaseImage().file
            },
            {
                doors: this.getDoorConfigs()
            });

        this.loading = true;

        return this.$http.post(this.appConfig.api_endpoint + '/api/email-design', data).then((response) => {
            return response;
        });

    }



    setupTestData() {

        this.setBaseImage({
            file: '1470624950house-hires.jpg',
            url: 'http://sl-visualiser-cms.app/uploads/1470624950house-hires.jpg',
            width: 1000,
            height: 563
        });

        this.addDoor({type: 'double', points: [516, 383, 874, 385, 874, 541, 514, 539]});
        this.addDoor({type: 'double', points: [116, 383, 474, 385, 474, 541, 114, 539]});

    }
}



// WEBPACK FOOTER //
// ./src/js/user-session.service.js